export default {
    SET_WORK_PROGRESS_STATUS_LIST(state, payload) {
        state.work_progress_status_list = payload;
    },
}